var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInformation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_3846",
    "data-name": "\\uADF8\\uB8F9 3846",
    transform: "translate(6851 -3751)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_5087",
    "data-name": "\\uD328\\uC2A4 5087",
    d: "M8,0a8,8,0,1,0,8,8A8.009,8.009,0,0,0,8,0M8,3.28A1.04,1.04,0,1,1,6.96,4.32,1.04,1.04,0,0,1,8,3.28m1.92,9.04H6.4a.64.64,0,1,1,0-1.28H7.52V7.52H6.88a.64.64,0,1,1,0-1.28H8.16a.641.641,0,0,1,.64.64v4.16H9.92a.64.64,0,1,1,0,1.28",
    transform: "translate(-6851 3751)",
    fill: "#00d810"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformation);
export default __webpack_public_path__ + "static/media/information.b5508e4f1fc7ea7bb238dd30f51b6098.svg";
export { ForwardRef as ReactComponent };